export const branches = {

    data : [

        {
            id:1,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.3481508955892!2d80.20065017483986!3d12.885320587422184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525b50b2528c3d%3A0x271ece6cc041899e!2sOUTLAST%20FC%20FOOTBALL%20ACADEMY%20(%20bollineni%20hillside%20Perumabakkam)!5e0!3m2!1sen!2sin!4v1746958389282!5m2!1sen!2sin",
            locatin:"Perumbakkam",
            contact:"784 588 8611",
            image : "assets/perumbakam.jpg",
        },
         {
            id:2,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62208.32729411144!2d80.11951904863278!3d12.970542800000022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d6790f4f7bf%3A0x11c0055b4fe03a1b!2sOUTLAST%20FOOTBALL%20ACADEMY%20(PUZHUTHIVAKKAM)!5e0!3m2!1sen!2sin!4v1747329414782!5m2!1sen!2sin",
            locatin:"Puzhuthivakkam",
            contact:"784 588 8611",
            image:"assets/puzuthivakam.jpg",
        
        },

         {
            id:3,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62208.32729411144!2d80.11951904863278!3d12.970542800000022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525f30ab7c106f%3A0xd2a05371126172b6!2sOUTLAST%20FC%20%26%20RED%20CLASSIC!5e0!3m2!1sen!2sin!4v1747329519687!5m2!1sen!2sin",
            locatin:"Santhoshapuram",
            contact:"784 588 8611",
            image:"assets/santhospuram.jpg",
        
        },

        
         {
            id:4,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62219.725489063225!2d80.1236473486328!3d12.924884699999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d0de4d57f33%3A0xfaa6c5d8ab060bc5!2sOUTLAST%20FC%20(%20AKG%20SCHOOL)%20PALLIKARANI!5e0!3m2!1sen!2sin!4v1747329590672!5m2!1sen!2sin",
            locatin:"Pallikarani",
            contact:"784 588 8611",
            image:"assets/palikarani.jpg",
        
        },

         {
            id:5,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62219.725489063225!2d80.1236473486328!3d12.924884699999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d171e657387%3A0xa5b5307476c0206d!2sOUTLAST%20FOOTBALL%20ACADEMY%20(%20NANGANALLUR)!5e0!3m2!1sen!2sin!4v1747329656576!5m2!1sen!2sin",
            locatin:"Nanganallur",
            contact:"784 588 8611",
            image:"assets/nanganallur.jpg",
        
        },

         {
            id:6,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62219.725489063225!2d80.1236473486328!3d12.924884699999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d476c8def17%3A0xfbdbc814c6fe091e!2sOUTLAST%20FOOTBALL%20ACADEMY%20(MADIPAKKAM)!5e0!3m2!1sen!2sin!4v1747329713787!5m2!1sen!2sin",
            locatin:"Madipakkam",
            contact:"784 588 8611",
            image:"assets/madipakam.jpg",
        
        },

         {
            id:7,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.974821361981!2d80.23333457484023!3d12.9093397874004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d78227cb413%3A0x73670b4a064c2396!2sOUTLAST%20FOOTBALL%20ACADEMY%20karapakkam!5e0!3m2!1sen!2sin!4v1747367013318!5m2!1sen!2sin",
            locatin:"karapakkam",
            contact:"784 588 8611",
            image:"assets/karapakkam.jpg",
        
        },

          {
            id:8,
            map:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.651487988588!2d80.14929469999998!3d12.93010689999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525f143c4349a9%3A0x531de50cbb481753!2sOUTLAST%20FOOTBALL%20ACADEMY%20(CHITLAPAKKAM)!5e0!3m2!1sen!2sin!4v1747367117866!5m2!1sen!2sin",
            locatin:"Chitlapakkam",
            contact:"784 588 8611",
            image:"assets/chitalapakam.jpg",
        
        },



    ]




}